import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, ['status', 'index', 'locationIndex', 'type']);
  const modifyBusinessUnit = `modifyBusinessUnit(input: ${dataModify})`;
  return gql`
  mutation {
    ${modifyBusinessUnit} {
      id
    }
  }
`;
};
